import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';

export const StackLoading = styled(Stack)({
  '.dot': {
    width: 8,
    height: 8,
    backgroundColor: 'black',
    borderRadius: '50%',
    animation: 'dotBounce 1.0s infinite ease-in-out',
  },
  '.dot:nth-child(1)': {
    animationDelay: '0s',
  },
  '.dot:nth-child(2)': {
    animationDelay: '0.2s',
  },
  '.dot:nth-child(3)': {
    animationDelay: '0.4s',
  },
  '@keyframes dotBounce': {
    '0%, 100%': {
      transform: 'translateY(0)',
    },
    '65%': {
      transform: 'translateY(-6px)',
    },
  },
});

export const BoxMessage = styled(Box)({
  position: 'relative',
  width: '100%',
  borderRadius: '10px',
  borderBottomLeftRadius: 0,
  padding: '6px',
  wordBreak: 'break-word',
  overflow: 'hidden',
  display: 'inline-flex',
  flexGrow: 1,
  marginBottom: '16px',
});

export const AvatarStyled = styled(Avatar)({
  width: 40,
  height: 40,
});
